import _ from 'lodash';

const exported = {
  limit(data, axis) {
    let values = _.map(values, axis);
    return {
      max: _.max(values),
      min: _.min(values)
    };
  },

  toX(x, scale, offset) {
    return `${x * (scale || this.props.scale).x + (offset || 0)}%`;
  },

  toY(y, scale, offset) {
    let miny = 0;
    if ((this.props.min != null ? this.props.min.y : undefined) < Infinity) {
      miny = this.props.min.y;
    }
    return `${100 - (y - miny) * (scale || this.props.scale).y + (offset || 0)}%`;
  }
};

export default exported;

export const { limit, toX, toY } = exported;
